import validate from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/middleware/auth.global.ts";
import manifest_45route_45rule from "/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/ingtomaszatloukal/snadnee/jrk-obcan/.vapor/build/app/resources/nuxt/admin/node_modules/@nuxt-alt/auth/dist/runtime/core/middleware.mjs")
}